module.exports = __webpack_public_path__ + "assets/bf1738c3b93a09151b9a0f540a9dab3f.ttf";